import { v7 as uuidv7 } from "uuid";

export const m2 = {
  "2_module_4_Switch": {
    id: 1,
    width: 567,
    height: 597,
    wifiTop: "none",
    wifiLeft: 19,
    wifiBottom: 270,
    marginRight: 120,
    type: "switch",
    space: 1,
    value: "2m_4switch",
    accessory: [
      {
        id: uuidv7(),
        list: [
          {
            id: uuidv7(),
            type: "2",
            marginTop: 26 + 6,
            marginLeft: 20 + 6 + 8,
            top: 26 + 6,
            left: 20 + 6 + 8,
          },
          {
            id: uuidv7(),
            type: "2",
            marginTop: 129 + 6,
            marginLeft: 20 + 6 + 8,
            bottom: 26 + 6,
            left: 20 + 6 + 8,
          },
        ],
      },
      {
        id: uuidv7(),
        list: [
          {
            id: uuidv7(),
            type: "2",
            marginTop: 15 + 6,
            marginLeft: 87 - 15 + 6 - 11,
            top: 26 + 6,
            right: 20 + 6 + 11,
          },
          {
            id: uuidv7(),
            type: "2",
            marginTop: 129 + 6,
            marginLeft: 87 - 15 + 6 - 11,
            bottom: 26 + 6,
            right: 20 + 6 + 11,
          },
        ],
      },
    ],
  },
  "2_module_1_Switch": {
    id: 1,
    width: 567,
    height: 597,
    wifiTop: "none",
    wifiLeft: 39 - 5,
    wifiBottom: 270,
    marginRight: 120,
    space: 1,
    type: "switch",
    value: "2m_1switch",
    accessory: [
      {
        id: uuidv7(),
        list: [
          {
            id: uuidv7(),
            type: "2",
            marginTop: 189 + 6 + 9,
            marginLeft: 174 + 6 + 8,
            top: 189 + 6 + 9,
            left: 174 + 6 + 8,
          },
        ],
      },
    ],
  },
  "2_module_4_curtain": {
    id: 1,
    width: 567,
    height: 597,
    wifiTop: "none",
    wifiLeft: 19,
    wifiBottom: 270,
    marginRight: 120,
    space: 1,
    type: "switch",
    value: "2m_4curtain",
    accessory: [
      {
        id: uuidv7(),
        list: [
          {
            id: uuidv7(),
            type: "curtain-up",
            marginTop: 26 + 6,
            marginLeft: 20 + 6 + 8,
            top: 26 + 6,
            left: 20 + 6 + 8,
          },
          {
            id: uuidv7(),
            type: "curtain-down",
            marginTop: 129 + 6,
            marginLeft: 20 + 6 + 8,
            bottom: 26 + 6,
            left: 20 + 6 + 8,
          },
        ],
      },
      {
        id: uuidv7(),
        list: [
          {
            id: uuidv7(),
            type: "curtain-up",
            marginTop: 15 + 6,
            marginLeft: 87 - 15 + 6 - 11,
            top: 26 + 6,
            right: 20 + 6 + 11,
          },
          {
            id: uuidv7(),
            type: "curtain-down",
            marginTop: 129 + 6,
            marginLeft: 87 - 15 + 6 - 11,
            bottom: 26 + 6,
            right: 20 + 6 + 11,
          },
        ],
      },
    ],
  },
};

export const prices = {
  plate: {
    1: { glass: 2248, acrylic: 1298 },
    2: { glass: 2748, acrylic: 1748 },
    3: { glass: 3098, acrylic: 2098 },
    4: { glass: 3498, acrylic: 2548 },
    6: { glass: 0, acrylic: 3398 },
    9: { glass: 0, acrylic: 5248 },
  },
  module: {
    '2m_4switch': 12599,
    '2m_1switch': 12599,
    '2m_4curtain': 12599,
    '4m_7switch_master': 15599,
    '4m_1curtain_5switch_master': 15599,
    '4m_2curtain_3switch_master': 15599,
    '4m_1curtain_2switch_fan_master': 15599,
    '4m_4switch_fan_master': 15599,
    '6m_9switches_master': 20999,
    '6m_1curtain_7switches_master': 20999,
    '6m_2curtain_5switches_master': 20999,
    '6m_6switches_fan_master': 20999,
    '6m_1curtain_4switches_fan_master': 20999,
  },

  modularSwitch: {
    '4_switch': 3500,
    '2_switch': 3500,
    '1_switch': 3500,
    '1_fan': 3500,
  },
  accessory: {
    'Knob': 3999,
    'indian_socket': 799,
    'universal_socket': 1399,
    'international_socket': 1399,
    'rj11': 110,
    'rj45': 450,
    'hdmi': 4000,
    'usb': 1180,
    'blank': 20,
    'tv_socket': 200,
  }
}

export const codes = {
  plates_top: {
    glass: {
      black: {
        1: '2M Black Glass (GLAS0001)',
        2: '4M Black Glass (GLAS0003)',
        3: '6M Black Glass (GLAS0007)',
        4: '8M Black Glass (GLAS0011)',
      },
      white: {
        1: '2M White Glass (GLAS0002)',
        2: '4M White Glass (GLAS0005)',
        3: '6M White Glass (GLAS0009)',
        4: '8M White Glass (GLAS0014)',
      },
    },
    acrylic: {
      black: {
        1: '2M Black Acrylic (ACRY0001)',
        2: '4M Black Acrylic (ACRY0002)',
        3: '6M Black Acrylic (ACRY0003)',
        4: '8M Black Acrylic (ACRY0004)',
        6: '12M Black Acrylic (ACRY0005)',
        9: '16M Black Acrylic (ACRY0006)',
      },
      white: {
        1: '2M White Acrylic (ACRY0007)',
        2: '4M White Acrylic (ACRY0008)',
        3: '6M White Acrylic (ACRY0009)',
        4: '8M White Acrylic (ACRY0010)',
        6: '12M White Acrylic (ACRY0011)',
        9: '16M White Acrylic (ACRY0012)',
      },
    },
  },
  plate: {
    1: { white: '2M White Plate (ELAC0002)', black: '2M Black Plate (ELAC0001)' },
    2: { white: '4M White Plate (ELAC0004)', black: '4M Black Plate (ELAC0003)' },
    3: { white: '6M White Plate (ELAC0006)', black: '6M Black Plate (ELAC0005)' },
    4: { white: '8M White Plate (ELAC0008)', black: '8M Black Plate (ELAC0007)' },
    6: { white: '12M White Plate (ELAC0010)', black: '12M Black Plate (ELAC0009)' },
    9: { white: '16M White Plate (ELAC0012)', black: '16M Black Plate (ELAC0011)' },
  },
  module: {
    '2m_4switch': 'All Switch/4 Switch (PANELFL01)',
    '2m_1switch': '30A/1 Switch (PANELFL02)',
    '2m_4curtain': '2CH/Curtain Control (PANELFL07)',
    '4m_7switch_master': '7 Switch (PANELFL03)',
    '4m_1curtain_5switch_master': '1 Curtain + 5 Switch (PANELFL03)',
    '4m_2curtain_3switch_master': '2 Curtain + 3 Switch (PANELFL03)',
    '4m_1curtain_2switch_fan_master': '1 Curtain + 2 Switch + Fan (PANELFL10)',
    '4m_4switch_fan_master': '4 Switch + Fan (PANELFL10)',
    '6m_9switches_master': '9 Switch (PANELFL05)',
    '6m_1curtain_7switches_master': '1 Curtain + 7 Switch (PANELFL05)',
    '6m_2curtain_5switches_master': '2 Curtain + 5 Switch (PANELFL05)',
    '6m_6switches_fan_master': '6 Switch + Fan (PANELFL06)',
    '6m_1curtain_4switches_fan_master': '1 Curtain + 4 Switch + Fan (PANELFL06)',
  },
  accessory: {
    'Knob': 'Knob (ELAC0020)',
    'indian_socket': '6AMP Socket (ELAC0021)',
    'universal_socket': '16Amp Socket (ELAC0022)',
    'international_socket': 'International Socket (ELAC0023)',
    'rj11': 'RJ11/Telephone ELAC0024',
    'rj45': 'RJ45/Ethernet ELAC0025',
    'hdmi': 'HDMI (ELAC0026)',
    'usb': 'USB (ELAC0027)',
    'blank': 'Blank (ELAC0028)',
    'tv_socket': 'TV Socket (ELAC0029)',
  },
  modularSwitch: {
    '4_switch': 3500,
    '2_switch': 3500,
    '1_switch': 3500,
    '1_fan': 3500,
  },
}

export const m4 = {
  "4_module_7_switch_master": {
    id: 1,
    width: 1241,
    height: 597,
    wifiTop: "none",
    wifiLeft: 90 + 4,
    wifiBottom: 270,
    marginRight: 120,
    type: "switch",
    space: 2,
    value: "4m_7switch_master",
    accessory: [
      {
        id: uuidv7(),
        list: [
          { id: uuidv7(), type: "2", top: 26 + 6 - 3, left: 102 + 6 + 5 },
          { id: uuidv7(), type: "2", bottom: 26 + 6 + 3, left: 102 + 6 + 5 },
        ],
      },
      {
        id: uuidv7(),
        list: [
          { id: uuidv7(), type: "2", top: 26 + 6 - 3, left: 382 + 6 + 5 },
          { id: uuidv7(), type: "2", bottom: 26 + 6 + 3, left: 382 + 6 + 5 },
        ],
      },
      {
        id: uuidv7(),
        list: [
          { id: uuidv7(), type: "2", top: 26 + 6 - 3, left: 662 + 6 + 5 },
          { id: uuidv7(), type: "2", bottom: 26 + 6 + 3, left: 662 + 6 + 5 },
        ],
      },

      {
        id: uuidv7(),
        list: [
          { id: uuidv7(), type: "master", top: 26 + 6 - 3, left: 942 + 6 + 5 },
          { id: uuidv7(), type: "2", bottom: 26 + 6 + 3, left: 942 + 6 + 5 },
        ],
      },
    ],
  },
  "1_curtain_5_switch_master": {
    id: 1,
    width: 1241,
    height: 597,
    wifiTop: "none",
    wifiLeft: 90 + 4,
    wifiBottom: 270,
    marginRight: 120,
    type: "switch",
    space: 2,
    value: "4m_1curtain_5switch_master",
    accessory: [
      {
        id: uuidv7(),
        list: [
          { id: uuidv7(), type: "curtain-up", top: 26 + 6 - 3, left: 102 + 6 + 5 },
          { id: uuidv7(), type: "curtain-down", bottom: 26 + 6 + 3, left: 102 + 6 + 5 },
        ],
      },
      {
        id: uuidv7(),
        list: [
          { id: uuidv7(), type: "2", top: 26 + 6 - 3, left: 382 + 6 + 5 },
          { id: uuidv7(), type: "2", bottom: 26 + 6 + 3, left: 382 + 6 + 5 },
        ],
      },
      {
        id: uuidv7(),
        list: [
          { id: uuidv7(), type: "2", top: 26 + 6 - 3, left: 662 + 6 + 5 },
          { id: uuidv7(), type: "2", bottom: 26 + 6 + 3, left: 662 + 6 + 5 },
        ],
      },
      {
        id: uuidv7(),
        list: [
          { id: uuidv7(), type: "master", top: 26 + 6 - 3, left: 942 + 6 + 5 },
          { id: uuidv7(), type: "2", bottom: 26 + 6 - 3, left: 942 + 6 + 5 },
        ],
      },
    ],
  },
  "2_curtain_3_switch_master": {
    id: 1,
    width: 1241,
    height: 597,
    wifiTop: "none",
    wifiLeft: 90 + 4,
    wifiBottom: 270,
    marginRight: 120,
    space: 2,
    type: "switch",
    value: "4m_2curtain_3switch_master",
    accessory: [
      {
        id: uuidv7(),
        list: [
          { id: uuidv7(), type: "curtain-up", top: 26 + 6 - 3, left: 102 + 6 + 5 },
          { id: uuidv7(), type: "curtain-down", bottom: 26 + 6 + 3, left: 102 + 6 + 5 },
        ],
      },
      {
        id: uuidv7(),
        list: [
          { id: uuidv7(), type: "curtain-up", top: 26 + 6 - 3, left: 382 + 6 + 5 },
          { id: uuidv7(), type: "curtain-down", bottom: 26 + 6 + 3, left: 382 + 6 + 5 },
        ],
      },
      {
        id: uuidv7(),
        list: [
          { id: uuidv7(), type: "2", top: 26 + 6 - 3, left: 662 + 6 + 5 },
          { id: uuidv7(), type: "2", type: "2", bottom: 26 + 6 + 3, left: 662 + 6 + 5 },
        ],
      },
      {
        id: uuidv7(),
        list: [
          { id: uuidv7(), type: "master", top: 26 + 6 - 3, left: 942 + 6 + 5 },
          { id: uuidv7(), type: "2", bottom: 26 + 6 + 3, left: 942 + 6 + 5 },
        ],
      },
    ],
  },
  "1_curtain_2_switch_fan_master": {
    id: 1,
    width: 1241,
    height: 597,
    wifiTop: "none",
    wifiLeft: 90 + 4,
    wifiBottom: 270,
    marginRight: 120,
    space: 2,
    type: "switch",
    value: "4m_1curtain_2switch_fan_master",
    accessory: [
      {
        id: uuidv7(),
        list: [
          { id: uuidv7(), type: "curtain-up", top: 26 + 6 - 3, left: 102 + 6 + 5 },
          { id: uuidv7(), type: "curtain-down", bottom: 26 + 6 + 3, left: 102 + 6 + 5 },
        ],
      },
      {
        id: uuidv7(),
        list: [
          { id: uuidv7(), type: "2", top: 26 + 6 - 3, left: 382 + 6 + 5 },
          { id: uuidv7(), type: "2", bottom: 26 + 6 + 3, left: 382 + 6 + 5 },
        ],
      },
      {
        id: uuidv7(),
        list: [
          { id: uuidv7(), type: "fan-volume-up", top: 26 + 6 - 3, left: 662 + 6 + 5 },
          {
            id: uuidv7(),
            type: "fan-volume-down",
            bottom: 26 + 6 + 3,
            left: 662 + 6 + 5,
          },
        ],
      },
      {
        id: uuidv7(),
        list: [
          { id: uuidv7(), type: "fan-dot", top: 118 - 1, left: 896 + 3 },
          { id: uuidv7(), type: "fan-dot", top: 235 - 1, left: 896 + 3 },
          { id: uuidv7(), type: "fan-dot", top: 352 - 1, left: 896 + 3 },
          { id: uuidv7(), type: "fan-dot", top: 469 - 1, left: 896 + 3 },
        ],
      },
      {
        id: uuidv7(),
        list: [
          { id: uuidv7(), type: "master", top: 26 + 6 - 3, left: 942 + 6 + 5 },
          { id: uuidv7(), type: "fan", bottom: 26 + 6 + 3, left: 942 + 6 + 5 },
        ],
      },
    ],
  },
  "4_switch_fan_master": {
    id: 1,
    width: 1241,
    height: 597,
    wifiTop: "none",
    wifiLeft: 90 + 4,
    wifiBottom: 270,
    marginRight: 120,
    type: "switch",
    space: 2,
    value: "4m_4switch_fan_master",
    accessory: [
      {
        id: uuidv7(),
        list: [
          { id: uuidv7(), type: "2", top: 26 + 6 - 3, left: 102 + 6 + 5 },
          { id: uuidv7(), type: "2", bottom: 26 + 6 + 3, left: 102 + 6 + 5 },
        ],
      },
      {
        id: uuidv7(),
        list: [
          { id: uuidv7(), type: "2", top: 26 + 6 - 3, left: 382 + 6 + 5 },
          { id: uuidv7(), type: "2", bottom: 26 + 6 + 3, left: 382 + 6 + 5 },
        ],
      },
      {
        id: uuidv7(),
        list: [
          { id: uuidv7(), type: "fan-volume-up", top: 26 + 6 - 3, left: 662 + 6 + 5 },
          {
            id: uuidv7(),
            type: "fan-volume-down",
            bottom: 26 + 6 + 3,
            left: 662 + 6 + 5,
          },
        ],
      },
      {
        id: uuidv7(),
        list: [
          { id: uuidv7(), type: "fan-dot", top: 118 - 2, left: 896 + 3 },
          { id: uuidv7(), type: "fan-dot", top: 235 - 2, left: 896 + 3 },
          { id: uuidv7(), type: "fan-dot", top: 352 - 2, left: 896 + 3 },
          { id: uuidv7(), type: "fan-dot", top: 469 - 2, left: 896 + 3 },
        ],
      },
      {
        id: uuidv7(),
        list: [
          { id: uuidv7(), type: "master", top: 26 + 6 - 3, left: 942 + 6 + 5 },
          { id: uuidv7(), type: "fan", bottom: 26 + 6 + 3, left: 942 + 6 + 5 },
        ],
      },
    ],
  },
};

export const m6 = {
  "8m_6m_9swithces_master": {
    id: 1,
    width: 1936,
    height: 596,
    wifiTop: "none",
    wifiLeft: 216,
    wifiBottom: 270,
    marginRight: 120,
    type: "switch",
    space: 3,
    value: "6m_9switches_master",
    accessory: [
      {
        id: uuidv7(),
        list: [
          { id: uuidv7(), type: "2", top: 26 + 6, left: 179 + 6 + 4 },
          { id: uuidv7(), type: "2", bottom: 26 + 6, left: 179 + 6 + 4 },
        ],
      },
      {
        id: uuidv7(),
        list: [
          { id: uuidv7(), type: "2", top: 26 + 6, left: 522 + 6 + 4 },
          { id: uuidv7(), type: "2", bottom: 26 + 6, left: 522 + 6 + 4 },
        ],
      },
      {
        id: uuidv7(),
        list: [
          { id: uuidv7(), type: "2", top: 26 + 6, left: 865 + 6 + 4 },
          { id: uuidv7(), type: "2", bottom: 26 + 6, left: 865 + 6 + 4 },
        ],
      },
      {
        id: uuidv7(),
        list: [
          { id: uuidv7(), type: "2", top: 26 + 6, left: 1208 + 6 + 4 },
          { id: uuidv7(), type: "2", bottom: 26 + 6, left: 1208 + 6 + 4 },
        ],
      },
      {
        id: uuidv7(),
        list: [
          { id: uuidv7(), type: "master", top: 26 + 6, left: 1551 + 6 + 4 },
          { id: uuidv7(), type: "2", bottom: 26 + 6, left: 1551 + 6 + 4 },
        ],
      },
    ],
  },
  "8m_6m_1curtain_7switches_master": {
    id: 1,
    width: 1936,
    height: 596,
    wifiTop: "none",
    wifiLeft: 216,
    wifiBottom: 270,
    marginRight: 120,
    type: "switch",
    space: 3,
    value: "6m_1curtain_7switches_master",
    accessory: [
      {
        id: uuidv7(),
        list: [
          { id: uuidv7(), type: "curtain-up", top: 26 + 6, left: 179 + 6 + 4 },
          { id: uuidv7(), type: "curtain-down", bottom: 26 + 6, left: 179 + 6 + 4 },
        ],
      },

      {
        id: uuidv7(),
        list: [
          { id: uuidv7(), type: "2", type: "2", top: 26 + 6, left: 522 + 6 + 4 },
          { id: uuidv7(), type: "2", bottom: 26 + 6, left: 522 + 6 + 4 },
        ],
      },
      {
        id: uuidv7(),
        list: [
          { id: uuidv7(), type: "2", top: 26 + 6, left: 865 + 6 + 4 },
          { id: uuidv7(), type: "2", bottom: 26 + 6, left: 865 + 6 + 4 },
        ],
      },
      {
        id: uuidv7(),
        list: [
          { id: uuidv7(), type: "2", top: 26 + 6, left: 1208 + 6 + 4 },
          { id: uuidv7(), type: "2", bottom: 26 + 6, left: 1208 + 6 + 4 },
        ],
      },
      {
        id: uuidv7(),
        list: [
          { id: uuidv7(), type: "master", top: 26 + 6, left: 1551 + 6 + 4 },
          { id: uuidv7(), type: "2", bottom: 26 + 6, left: 1551 + 6 + 4 },
        ],
      },
    ],
  },
  "8m_6m_2curtain_5switches_master": {
    id: 1,
    width: 1936,
    height: 596,
    wifiTop: "none",
    wifiLeft: 216,
    wifiBottom: 270,
    marginRight: 120,
    type: "switch",
    space: 3,
    value: "6m_2curtain_5switches_master",
    accessory: [
      {
        id: uuidv7(),
        list: [
          { id: uuidv7(), type: "curtain-up", top: 26 + 6, left: 179 + 6 + 4 },
          { id: uuidv7(), type: "curtain-down", bottom: 26 + 6, left: 179 + 6 + 4 },
        ],
      },
      {
        id: uuidv7(),
        list: [
          { id: uuidv7(), type: "curtain-up", top: 26 + 6, left: 522 + 6 + 4 },
          { id: uuidv7(), type: "curtain-down", bottom: 26 + 6, left: 522 + 6 + 4 },
        ],
      },
      {
        id: uuidv7(),
        list: [
          { id: uuidv7(), type: "2", top: 26 + 6, left: 865 + 6 + 4 },
          { id: uuidv7(), type: "2", bottom: 26 + 6, left: 865 + 6 + 4 },
        ],
      },
      {
        id: uuidv7(),
        list: [
          { id: uuidv7(), type: "2", top: 26 + 6, left: 1208 + 6 + 4 },
          { id: uuidv7(), type: "2", bottom: 26 + 6, left: 1208 + 6 + 4 },
        ],
      },
      {
        id: uuidv7(),
        list: [
          { id: uuidv7(), type: "master", top: 26 + 6, left: 1551 + 6 + 4 },
          { id: uuidv7(), type: "2", bottom: 26 + 6, left: 1551 + 6 + 4 },
        ],
      },
    ],
  },
  "8m_6m_6switches_fan_master": {
    id: 1,
    width: 1936,
    height: 596,
    wifiTop: "none",
    wifiLeft: 216,
    wifiBottom: 270,
    marginRight: 120,
    type: "switch",
    space: 3,
    value: "6m_6switches_fan_master",
    accessory: [
      {
        id: uuidv7(),
        list: [
          { id: uuidv7(), type: "2", top: 26 + 6, left: 179 + 6 + 4 },
          { id: uuidv7(), type: "2", bottom: 26 + 6, left: 179 + 6 + 4 },
        ],
      },
      {
        id: uuidv7(),
        list: [
          { id: uuidv7(), type: "2", type: "2", top: 26 + 6, left: 522 + 6 + 4 },
          { id: uuidv7(), type: "2", bottom: 26 + 6, left: 522 + 6 + 4 },
        ],
      },
      {
        id: uuidv7(),
        list: [
          { id: uuidv7(), type: "2", top: 26 + 6, left: 865 + 6 + 4 },
          { id: uuidv7(), type: "2", bottom: 26 + 6, left: 865 + 6 + 4 },
        ],
      },
      {
        id: uuidv7(),
        list: [
          { id: uuidv7(), type: "fan-volume-up", top: 26 + 6, left: 1208 + 6 + 4 },
          {
            id: uuidv7(),
            type: "fan-volume-down",
            bottom: 26 + 6,
            left: 1208 + 6,
          },
        ],
      },
      {
        id: uuidv7(),
        list: [
          { id: uuidv7(), type: "fan-dot", top: 118 - 1, left: 1472 + 6 },
          { id: uuidv7(), type: "fan-dot", top: 235 - 1, left: 1472 + 6 },
          { id: uuidv7(), type: "fan-dot", top: 352 - 1, left: 1472 + 6 },
          { id: uuidv7(), type: "fan-dot", top: 469 - 1, left: 1472 + 6 },
        ],
      },
      {
        id: uuidv7(),
        list: [
          { id: uuidv7(), type: "master", top: 26 + 6, left: 1551 + 6 + 4 },
          { id: uuidv7(), type: "fan", bottom: 26 + 6, left: 1551 + 6 + 4 },
        ],
      },
    ],
  },
  "8m_6m_1curtain_4switches_fan_master": {
    id: 1,
    width: 1936,
    height: 596,
    wifiTop: "none",
    wifiLeft: 216,
    wifiBottom: 270,
    marginRight: 120,
    type: "switch",
    space: 3,
    value: "6m_1curtain_4switches_fan_master",
    accessory: [
      {
        id: uuidv7(),
        list: [
          { id: uuidv7(), type: "curtain-up", top: 26 + 6, left: 179 + 6 + 4 },
          { id: uuidv7(), type: "curtain-down", bottom: 26 + 6, left: 179 + 6 + 4 },
        ],
      },
      {
        id: uuidv7(),
        list: [
          { id: uuidv7(), type: "2", type: "2", top: 26 + 6, left: 522 + 6 + 4 },
          { id: uuidv7(), type: "2", bottom: 26 + 6, left: 522 + 6 + 4 },
        ],
      },
      {
        id: uuidv7(),
        list: [
          { id: uuidv7(), type: "2", top: 26 + 6, left: 865 + 6 + 4 },
          { id: uuidv7(), type: "2", bottom: 26 + 6, left: 865 + 6 + 4 },
        ],
      },
      {
        id: uuidv7(),
        list: [
          { id: uuidv7(), type: "fan-volume-up", top: 26 + 6, left: 1208 + 6 + 4 },
          {
            id: uuidv7(),
            type: "fan-volume-down",
            bottom: 26 + 6,
            left: 1208 + 6 + 4,
          },
        ],
      },
      {
        id: uuidv7(),
        list: [
          { id: uuidv7(), type: "fan-dot", top: 118 - 1, left: 1472 + 6 },
          { id: uuidv7(), type: "fan-dot", top: 235 - 1, left: 1472 + 6 },
          { id: uuidv7(), type: "fan-dot", top: 352 - 1, left: 1472 + 6 },
          { id: uuidv7(), type: "fan-dot", top: 469 - 1, left: 1472 + 6 },
        ],
      },
      {
        id: uuidv7(),
        list: [
          { id: uuidv7(), type: "master", top: 26 + 6, left: 1551 + 6 + 4 },
          { id: uuidv7(), type: "fan", bottom: 26 + 6, left: 1551 + 6 + 4 },
        ],
      },
    ],
  },
};

export const moduleTouchsiwtchs = {
  "4_switch": {
    id: 1,
    width: 567,
    height: 597,
    wifiTop: "none",
    wifiLeft: 39,
    wifiBottom: 270,
    marginRight: 120,
    type: "switch",
    value: "4switch",
    space: 1,
    isDisplayWifi: false,
    accessory: [
      {
        id: uuidv7(),
        list: [
          {
            id: uuidv7(),
            type: "2",
            marginTop: 26 + 6,
            marginLeft: 20 + 6,
            top: 68,
            left: 71,
          },
          {
            id: uuidv7(),
            type: "2",
            marginTop: 129 + 6,
            marginLeft: 20 + 6,
            bottom: 68,
            left: 71,
          },
        ],
      },
      {
        id: uuidv7(),
        list: [
          {
            id: uuidv7(),
            type: "2",
            marginTop: 15 + 6,
            marginLeft: 87 - 15 + 6,
            top: 68,
            right: 71,
          },
          {
            id: uuidv7(),
            type: "2",
            marginTop: 129 + 6,
            marginLeft: 87 - 15 + 6,
            bottom: 68,
            right: 71,
          },
        ],
      },
      {
        id: uuidv7(),
        list: [
          {
            id: uuidv7(),
            type: "moduler_dot",
            top: 298,
            left: 283,
          },
        ],
      },
    ],
  },

  "2_switch": {
    id: 1,
    width: 567,
    height: 597,
    wifiTop: "none",
    wifiLeft: 39,
    wifiBottom: 270,
    marginRight: 120,
    type: "switch",
    value: "2switch",
    space: 1,
    isDisplayWifi: false,
    accessory: [
      {
        id: uuidv7(),
        list: [
          {
            id: uuidv7(),
            type: "2",
            marginTop: 26 + 6,
            marginLeft: 20 + 6,
            top: 202,
            left: 57,
          },
          {
            id: uuidv7(),
            type: "2",
            marginTop: 129 + 6,
            marginLeft: 20 + 6,
            top: 202,
            right: 57,
          },
        ],
      },
      {
        id: uuidv7(),
        list: [
          {
            id: uuidv7(),
            type: "moduler_dot",
            top: 298,
            left: 283,
          },
        ],
      },
    ],
  },
  "1_switch": {
    id: 1,
    width: 567,
    height: 597,
    wifiTop: "none",
    wifiLeft: 39,
    wifiBottom: 270,
    marginRight: 120,
    type: "switch",
    value: "1switch",
    space: 1,
    isDisplayWifi: false,
    accessory: [
      {
        id: uuidv7(),
        list: [
          {
            id: uuidv7(),
            type: "2",
            marginTop: 26 + 6,
            marginLeft: 20 + 6,
            top: 204,
            left: 189,
          },
        ],
      },
      {
        id: uuidv7(),
        list: [
          {
            id: uuidv7(),
            type: "moduler_dot",
            top: 298,
            left: 283,
          },
        ],
      },
    ],
  },

  "1_fan": {
    id: 1,
    width: 567,
    height: 597,
    wifiTop: "none",
    wifiLeft: 39,
    wifiBottom: 270,
    marginRight: 120,
    type: "switch",
    value: "1fan",
    space: 1,
    isDisplayWifi: false,
    accessory: [
      {
        id: uuidv7(),
        list: [{ id: uuidv7(), type: "fan", top: 207, left: 55 }],
      },
      {
        id: uuidv7(),
        list: [
          { id: uuidv7(), type: "fan-volume-up", top: 62, left: 199 },
          {
            id: uuidv7(),
            type: "fan-volume-down",
            bottom: 62,
            left: 199,
          },
        ],
      },

      {
        id: uuidv7(),
        list: [
          { id: uuidv7(), type: "fan-dot", top: 149, right: 130 },
          { id: uuidv7(), type: "fan-dot", top: 221, right: 130 },
          { id: uuidv7(), type: "fan-dot", top: 297, right: 130 },
          { id: uuidv7(), type: "fan-dot", top: 373, right: 130 },
          { id: uuidv7(), type: "fan-dot", top: 449, right: 130 },
        ],
      },
      {
        id: uuidv7(),
        list: [
          {
            id: uuidv7(),
            type: "moduler_dot",
            top: 298,
            left: 293,
          },
        ],
      },
    ],
  },
};

export const modueProSwitchs = {
  "8m_6m_9swithces_master": {
    id: 1,
    width: 2921,
    height: 1037,
    wifiLeft: 457,
    wifiBottom: 490,
    marginRight: 120,
    type: "switch",
    value: '8m_6m_9swithces_master',
    space: 10,
    accessory: [
      {
        id: uuidv7(),
        list: [
          { id: uuidv7(), type: "2", top: 224, left: 420 },
          { id: uuidv7(), type: "2", bottom: 224, left: 420 },
        ],
      },
      {
        id: uuidv7(),
        list: [
          { id: uuidv7(), type: "2", top: 224, left: 730 },
          { id: uuidv7(), type: "2", bottom: 224, left: 730 },
        ],
      },
      {
        id: uuidv7(),
        list: [
          { id: uuidv7(), type: "2", top: 224, left: 1040 },
          { id: uuidv7(), type: "2", bottom: 224, left: 1040 },
        ],
      },
      {
        id: uuidv7(),
        list: [
          { id: uuidv7(), type: "2", top: 224, left: 1350 },
          { id: uuidv7(), type: "2", bottom: 224, left: 1350 },
        ],
      },
      {
        id: uuidv7(),
        list: [
          { id: uuidv7(), type: "master", top: 224, left: 1660 },
          { id: uuidv7(), type: "2", bottom: 224, left: 1660 },
        ],
      },

      {
        id: uuidv7(),
        list: [
          {
            id: uuidv7(),
            type: "2m_insider",
            bottom: 186,
            right: 390,
            content: null,
          },
        ],
      },
    ],
  },
  "8m_6m_6switches_fan_master": {
    id: 1,
    width: 2921,
    height: 1037,
    wifiLeft: 457,
    wifiBottom: 490,
    marginRight: 120,
    type: "switch",
    value: '8m_6m_6switches_fan_master',
    space: 10,
    accessory: [
      {
        id: uuidv7(),
        list: [
          { id: uuidv7(), type: "2", top: 224, left: 420 },
          { id: uuidv7(), type: "2", bottom: 224, left: 420 },
        ],
      },
      {
        id: uuidv7(),
        list: [
          { id: uuidv7(), type: "2", top: 224, left: 730 },
          { id: uuidv7(), type: "2", bottom: 224, left: 730 },
        ],
      },
      {
        id: uuidv7(),
        list: [
          { id: uuidv7(), type: "2", top: 224, left: 1040 },
          { id: uuidv7(), type: "2", bottom: 224, left: 1040 },
        ],
      },
      {
        id: uuidv7(),
        list: [
          { id: uuidv7(), type: "fan-volume-up", top: 224, left: 1350 },
          {
            id: uuidv7(),
            type: "fan-volume-down",
            bottom: 224,
            left: 1350,
          },
        ],
      },
      {
        id: uuidv7(),
        list: [
          { id: uuidv7(), type: "fan-dot", top: 330, left: 1599 },
          { id: uuidv7(), type: "fan-dot", top: 459, left: 1599 },
          { id: uuidv7(), type: "fan-dot", top: 576, left: 1599 },
          { id: uuidv7(), type: "fan-dot", top: 693, left: 1599 },
        ],
      },
      {
        id: uuidv7(),
        list: [
          { id: uuidv7(), type: "master", top: 224, left: 1660 },
          { id: uuidv7(), type: "fan", bottom: 224, left: 1660 },
        ],
      },
      {
        id: uuidv7(),
        list: [
          {
            id: uuidv7(),
            type: "2m_insider",
            bottom: 186,
            right: 390,
            content: null,
          },
        ],
      },
    ],
  },
};

export const Knob = {
  id: 1,
  width: 567,
  height: 596,
  marginRight: 120,
  space: 1,
  type: "Knob",
  value: "Knob",
  accessory: [],
};

export const indianSocket = {
  id: 1,
  width: 567,
  height: 596,
  marginRight: 120,
  space: 1,
  type: "indian_socket",
  value: "indian_socket",
  accessory: [],
};

export const universalSocket = {
  id: 1,
  width: 567,
  height: 596,
  marginRight: 120,
  space: 1,
  type: "universal_socket",
  value: "universal_socket",
  accessory: [],
};

export const interNationalSocket = {
  id: 1,
  width: 567,
  height: 596,
  marginRight: 120,
  space: 1,
  type: "international_socket",
  value: "international_socket",
  accessory: [],
};

export const rj11 = {
  id: 1,
  width: 283,
  height: 596,
  marginRight: 1,
  space: 0.5,
  type: "rj11",
  value: "rj11",
  accessory: [],
};

export const rj45 = {
  id: 1,
  width: 283,
  height: 596,
  marginRight: 1,
  type: "rj45",
  value: "rj45",
  space: 0.5,
  accessory: [],
};

export const usb = {
  id: 1,
  width: 283,
  height: 596,
  marginRight: 1,
  type: "usb",
  value: "usb",
  space: 0.5,
  accessory: [],
};

export const blank = {
  id: 1,
  width: 283,
  height: 596,
  marginRight: 1,
  type: "blank",
  value: "blank",
  space: 0.5,
  accessory: [],
};

export const tvsocket = {
  id: 1,
  width: 283,
  height: 596,
  marginRight: 1,
  type: "tv_socket",
  value: "tv_socket",
  space: 0.5,
  accessory: [],
};

export const m2Possiblity = [
  {
    id: 1,
    label: "(2M) 1 Switch",
    value: "2m_1switch",
    data: m2["2_module_1_Switch"],
  },
  {
    id: 2,
    label: "(2M) 4 Switch",
    value: "2m_4switch",
    data: m2["2_module_4_Switch"],
  },
  {
    id: 2,
    label: " (2M) 2 Curtain",
    value: "2m_4curtain",
    data: m2["2_module_4_curtain"],
  },
];

export const m4Possiblity = [
  {
    id: 4,
    label: "(4M) 7 Switch + master",
    value: "4_module_7_switch_master",
    data: m4["4_module_7_switch_master"],
  },
  {
    id: 5,
    label: "(4M) 1 Curtain + 5 Switch + master",
    value: "1_curtain_5_switch_master",
    data: m4["1_curtain_5_switch_master"],
  },
  {
    id: 6,
    label: "(4M) 2 Curtain + 3 Switch + master",
    value: "2_curtain_3_switch_master",
    data: m4["2_curtain_3_switch_master"],
  },
  {
    id: 7,
    label: "(4M) 1 Curtain + 2 Switch + fan + master",
    value: "1_curtain_2_switch_fan_master",
    data: m4["1_curtain_2_switch_fan_master"],
  },

  {
    id: 8,
    label: "(4M) 4 Switch + fan + master",
    value: "4_switch_fan_master",
    data: m4["4_switch_fan_master"],
  },
];

export const m6Possiblity = [
  {
    id: 15,
    label: "(6M) 9 Switches + master",
    value: "8m_6m_9swithces_master",
    data: m6["8m_6m_9swithces_master"],
  },
  {
    id: 16,
    label: "(6M) 1 Curtain + 7 Switch + master",
    value: "8m_6m_1curtain_7switches_master",
    data: m6["8m_6m_1curtain_7switches_master"],
  },
  {
    id: 16,
    label: "(6M) 2 Curtain + 5 Switch + master",
    value: "8m_6m_2curtain_5switches_master",
    data: m6["8m_6m_2curtain_5switches_master"],
  },
  {
    id: 16,
    label: "(6M) 6 Switch + Fan + master",
    value: "8m_6m_6switches_fan_master",
    data: m6["8m_6m_6switches_fan_master"],
  },
  {
    id: 17,
    label: "(6M) 1 curtain + 4 Switch + Fan + Master",
    value: "8m_6m_1curtain_4switches_fan_master",
    data: m6["8m_6m_1curtain_4switches_fan_master"],
  },
];

export const module_touch_switchs = [
  {
    id: 1,
    label: "(Modular Touch Switch) 4 Switch",
    value: "module_touch_switch_4switch",
    data: moduleTouchsiwtchs["4_switch"],
  },
  {
    id: 2,
    label: "(Modular Touch Switch) 2 Switch",
    value: "module_touch_switch_2switch",
    data: moduleTouchsiwtchs["2_switch"],
  },
  {
    id: 2,
    label: "(Modular Touch Switch) 1 Switch",
    value: "module_touch_switch_1switch",
    data: moduleTouchsiwtchs["1_switch"],
  },
  {
    id: 2,
    label: "(Modular Touch Switch) fan",
    value: "module_touch_switch_fan",
    data: moduleTouchsiwtchs["1_fan"],
  },
];

export const module_pro_switchs = [
  {
    id: 15,
    label: "(6M) 9 Switches + master",
    value: "8m_6m_9swithces_master",
    data: modueProSwitchs["8m_6m_9swithces_master"],
  },
  {
    id: 16,
    label: "(6M) 6 Switch + Fan + master",
    value: "8m_6m_6switches_fan_master",
    data: modueProSwitchs["8m_6m_6switches_fan_master"],
  },
];
